import { Typography, toast } from "@stardust-ds/react"
import Modal from "../../molecules/Modal"
import intl from "react-intl-universal"
import Select from "../../atoms/Select"
import Input from "../../atoms/Input"
import TextArea from "../../atoms/TextArea"
import styles from "./index.module.scss"
import RcmpSteps from "../../atoms/Steps"
import Button from "../../atoms/Button"
import ArrowLeftIcon from "../../../assets/icons/ArrowLeftIcon"
import ArrowRightIcon from "../../../assets/icons/ArrowRightIcon"
import RcmpTooltip from "../../atoms/Tooltip"
import RcmpCheckBox from "../../atoms/Checkbox"
import RcmpActivityField from "../ActivityField"
import { FormProvider, useForm, useFormContext } from "react-hook-form"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import PurePlusIcon from "../../../assets/icons/PurePlusIcon"
import { useContext, useEffect, useRef, useState } from "react"
import RcmpModalCustomFields from "../ModalCustomFields"
import RcmpModalCreateNewCustomField from "../../molecules/ModalCreateNewCustomField"
import useDataApi from "../../../hooks/useDataApi"
import {
  fnCreateActivityField,
  fnUpdateField as fnUpdateFields,
} from "../../../services/activityFields"
import { fnShowTutorial } from "../../../services/models"
import BoardContext from "../../../contexts/Board"
import EyeSlashIcon from "../../../assets/icons/EyeSlashIcon"
import EyeIcon from "../../../assets/icons/EyeIcon"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage"
import LinkShareIcon from "../../../assets/icons/LinkShareIcon"
import EmbedIcon from "../../../assets/icons/EmbedIcon"
import QrCodeIcon from "../../../assets/icons/QrCodeIcon"
import { QRCodeCanvas } from "qrcode.react"
import RcmpSelectUsers from "../../molecules/SelectUsers"
import FieldsContext from "../../../contexts/Fields"
import FormContext from "../../../contexts/Form"
import RcmpModalInfo from "../ModalInfo"
import {
  cDeadLineSlug,
  cResponsiblesSlug,
  cStatusSlug,
  dConclusionDateSlug,
  dCreationDateSlug,
} from "../../../constans/activity-slugs"
import AuthContext from "../../../contexts/Auth"

function RcmpFirstStep(props) {
  const { aBlocks, fnSetOblockSelected, register, setValue, errors, getValues } = props
  const [oOptions, fnSetOOptions] = useState([])
  useEffect(() => {
    const options = aBlocks.map((block) => ({
      label: block.opbl_cname,
      value: block.opbl_nid,
    }))
    fnSetOOptions(options)
  }, [aBlocks])

  function fnSelectedBlock(e) {
    fnSetOblockSelected(e)
    setValue("blockId", e, { shouldValidate: true, shouldDirty: true })
  }

  return (
    <div className={styles.modalContent}>
      <Typography type="l2" color="#415364">
        {intl.get("modal_new_form.select_block")}
      </Typography>
      <Select
        options={oOptions}
        onSelect={fnSelectedBlock}
        label={`${intl.get("modal_new_form.block")}*`}
        defaultValue={getValues("blockId") || ""}
      />
      {errors?.bloclId?.message && (
        <RcmpFormErrorMessage>{errors?.bloclId?.message}</RcmpFormErrorMessage>
      )}
      <div>
        <Input
          label={`${intl.get("modal_new_form.form_name")}*`}
          isFullWidth
          {...register("formName")}
        />
        <RcmpFormErrorMessage>{errors?.formName?.message}</RcmpFormErrorMessage>
      </div>
      <TextArea
        label={`${intl.get("modal_new_form.description_form")}`}
        {...register("formDescription")}
      />
      <RcmpFormErrorMessage>{errors?.formDescription?.message}</RcmpFormErrorMessage>
    </div>
  )
}
function RcmpSecondtStep(props) {
  const { fnSetResponsible, oCurrentBoard, setValue, register, getValues } = props

  function fnHandleResponsible(e) {
    setValue(`responsibles`, e, { shouldValidate: true, shouldDirty: true })
  }
  function fnHandleInputValue(e) {
    setValue("timeValue", e)
    return
  }

  const aOptionDeadLine = [
    {
      label: intl.get("modal_new_form.minutes"),
      value: "minute",
    },
    {
      label: intl.get("modal_new_form.hour"),
      value: "hour",
    },
    {
      label: intl.get("modal_new_form.day"),
      value: "day",
    },
    {
      label: intl.get("modal_new_form.week"),
      value: "week",
    },
    {
      label: intl.get("modal_new_form.month"),
      value: "month",
    },
  ]
  const initialValueTimeRanger = getValues("timeRanger")
  const oDefautlValueTimeRangerEdit = aOptionDeadLine.filter(
    (oOption) => oOption?.value === initialValueTimeRanger?.value,
  )
  return (
    <div className={styles.modalContentDeadLine}>
      <Typography type="l2" color="#415364">
        {intl.get("modal_new_form.select_responsibles")}
      </Typography>
      <RcmpSelectUsers
        multiSelect
        label={`${intl.get("BoardsPage.responsibles")}*`}
        onSelect={fnHandleResponsible}
        defaultValue={getValues("responsibles") || ""}
      />
      <div className={styles.deadLineArea}>
        <div className={styles.infoAreaDateLine}>
          <Typography type="l3" color="#415364">
            {intl.get("modal_new_form.deadline_execution")}
          </Typography>
          <RcmpTooltip>
            <Typography type="p2">{intl.get("modal_new_form.info")}</Typography>
          </RcmpTooltip>
        </div>
        <div className={styles.deadLineInput}>
          <Select
            options={aOptionDeadLine}
            placeholder={aOptionDeadLine[1].label}
            defaultValue={
              oDefautlValueTimeRangerEdit || { label: "Horas", value: "hour" }
            }
            width={"190px"}
            onSelect={(e) => {
              !e
                ? setValue("timeRanger", { label: "Horas", value: "hour" })
                : setValue("timeRanger", e)
            }}
          />
          <Input
            type={"number"}
            max={999}
            min={0}
            onChange={fnHandleInputValue}
            defaultValue={getValues("timeValue") || 1}
          />
          <div className={styles.checkboxArea}>
            <RcmpCheckBox
              cLabel={intl.get("modal_new_form.allow_evidence_upload")}
              cSize={"sm"}
              onChange={(e) => setValue("evidenceUpload", e.target.checked)}
              checked={getValues("evidenceUpload") ? true : false}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

function RcmpFieldsRow(props) {
  const {
    field,
    index,
    getValues,
    setValue,
    values,
    fnSetAValues,
    watch,
    aFields,
    fnSetAFields,
    bOnDraggingEnd,
    bIsEdit,
    bIsRemoved,
  } = props
  let bIsVisibleValue = bIsEdit ? values[index].isVisible : field.visible_new_form
  let bIsRequiredValue = bIsEdit ? values[index].required : field.ombf_brequired
  const [bIsVisible, fnSetBIsVisible] = useState(bIsVisibleValue)
  const [bIsRequired, fnSetBIsRequired] = useState(bIsRequiredValue)
  function fnObjectsHaveSameValues(obj1, obj2) {
    return obj1?.isVisible === obj2?.isVisible && obj1?.required === obj2?.required
  }

  let fieldParams = {
    fieldId: field.ombf_opfd_nid || field.opfd_nid,
    name: field?.opfd_cname,
    slug: field?.opfd_cslug,
    type: field?.opfd_ctype,
    isVisible: bIsVisible,
    required: bIsRequired,
    position: index,
  }
  useEffect(() => {
    if (
      field.ombf_opfd_nid === values[index].field_id ||
      (field.opfd_nid === values[index].field_id && bIsEdit)
    ) {
      fnSetBIsRequired(values[index].required)
      fnSetBIsVisible(values[index].isVisible)
    }
  }, [bIsRemoved])

  useEffect(() => {
    setValue(`fields.${[index]}`, fieldParams)
    if (!fnObjectsHaveSameValues(getValues(`fields.${[index]}`), values[index])) {
      const tempValue = [...values]
      tempValue[index] = fieldParams
      fnSetAValues(tempValue)

      const tempValueFields = [...aFields]
      const newValuesUpdated = {
        ...tempValueFields[index],
        visible_new_form: bIsVisible,
        ombf_brequired: bIsRequired,
      }
      tempValueFields[index] = newValuesUpdated
      fnSetAFields(tempValueFields)
    }
  }, [bIsVisible, bIsRequired])
  useEffect(() => {
    if (bOnDraggingEnd === -1) return
    aFields.map(async (temp, i) => {
      const newValue = {
        fieldId: temp.ombf_opfd_nid || temp.opfd_nid,
        name: temp?.opfd_cname,
        slug: temp?.opfd_cslug,
        type: temp?.opfd_ctype,
        isVisible: temp.visible_new_form,
        required: temp.ombf_brequired,
        position: i,
      }
      await setValue(`fields[${i}]`, newValue)

      return temp
    })
    let newSetting = aFields.map((temp, i) => {
      if (
        temp.ombf_opfd_nid === field.ombf_opfd_nid ||
        (temp.opfd_nid === field.opfd_nid && !bIsEdit)
      ) {
        fnSetBIsRequired(temp.ombf_brequired)
        fnSetBIsVisible(temp.visible_new_form)
      }
      const bIsVisibleField = bIsVisible
      return {
        ...temp,
        visible_new_form: temp.visible_new_form,
        ombf_brequired: temp.ombf_brequired,
      }
    })
    fnSetAFields(newSetting)
  }, [bOnDraggingEnd])

  function fnHandleOnChangeFieldVisibility() {
    fnSetBIsVisible((prev) => !prev)
    fieldParams.isVisible = !bIsVisible

    if (bIsVisible) fnSetBIsRequired(false)
  }

  return (
    <Draggable draggableId={`modelActivityField-${index}`} index={index}>
      {(provided, snapshot) => {
        return (
          <div
            className={styles.rowField}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div className={styles.field}>
              <div className={styles.field}>
                <RcmpActivityField
                  {...field}
                  opfd_cname={field?.opfd_cname}
                  ombf_bautofill={field?.ombf_bautofill}
                  opfd_cslug={field?.opfd_cslug}
                  opfd_ctype={field?.opfd_ctype}
                  opfd_nid={field?.opfd_nid}
                  bIsDraggable={true}
                  bIsDisabled={true}
                  bIsEditModel={true}
                />
              </div>
              <div className={styles.actionArea}>
                <RcmpCheckBox
                  cLabel={intl.get("modal_new_form.required")}
                  cSize="sm"
                  onChange={(e) => {
                    ; (fieldParams.required = e.target.checked),
                      fnSetBIsRequired((prev) => !prev)
                  }}
                  checked={bIsRequired}
                  disabled={!bIsVisible}
                />
                <div onClick={fnHandleOnChangeFieldVisibility}>
                  {!bIsVisible ? (
                    <EyeSlashIcon fill="#FF3541" />
                  ) : (
                    <EyeIcon fill="#1ECB4F" />
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Draggable>
  )
}

function RcmpThirdStep(props) {
  const {
    bIsOpen,
    nStep,
    setValue,
    getValues,
    aFields,
    fnSetAFields,
    aSettingForm,
    fnSetASettingForm,
    watch,
    trigger,
    bIsEdit,
  } = props
  const containerRef = useRef(null)
  const [aNewFields, fnSetANewFields] = useState([])
  const [nInitialHeight, fnSetnInitialHeight] = useState(0)
  const [bOpenCustomField, fnSetBOpenCustomFields] = useState(false)
  const [bOpenWarningModal, fnSetBOpenWarningModal] = useState(true)
  const [bDisableButton, fnSetBDisableButton] = useState(false)
  const [bOpenModalNewCustomField, fnSetBOpenModalNewCustomField] = useState(false)
  const [bOpeEditCustomField, fnSetBOpeEditCustomField] = useState(false)
  const [oCustomField, fnSetOCustomField] = useState()
  const [bIsRemoved, fnSetBIsRemoved] = useState(false)
  const [oCreateActivityFieldRes, fnCreateActivityFielReq] =
    useDataApi(fnCreateActivityField)
  const [oShowTutorialRes, fnShowTutorialReq] = useDataApi(fnShowTutorial)
  const [cFieldRequired, fnSetCFieldRequired] = useDataApi("not_required")
  const [aRadioSelect, fnSetARadioSelect] = useState([])
  const [bOnDraggingEnd, fnSetBOnDraggingEnd] = useState(-1)
  const blockName = getValues("blockId")
  const [oUpdateFieldRes, fnUpdateField] = useDataApi(fnUpdateFields)
  const { fnRefreshCurrentBoard } = useContext(BoardContext)

  useEffect(() => {
    if (nStep !== 3) return
    if (!getValues("timeValue")) {
      setValue("timeValue", 1)
    }
    if (!getValues("timeRanger")) {
      setValue("timeRanger", { label: "Horas", value: "hour" })
    }

    if (!getValues("evidenceUpload")) {
      setValue("evidenceUpload", false)
    }
  }, [nStep])

  async function handleDragEnd(result) {
    if (!result.destination) return

    let tempData = [...aFields]
    let [fieldOrder] = tempData.splice(result.source.index, 1)
    tempData.splice(result.destination.index, 0, fieldOrder)
    const aNewPosition = tempData.map((temp, i) => ({
      ...temp,
      ombf_opfd_nid: temp.ombf_opfd_nid ? temp.ombf_opfd_nid : temp.opfd_nid,
      ombf_bautofill: temp.ombf_bautofill || false,
      ombf_brequired: temp.ombf_brequired,
      ombf_nposition: i,
    }))

    fnSetAFields(aNewPosition)
    fnSetBOnDraggingEnd((prev) => prev + 1)
  }

  //add new fields in the model
  useEffect(() => {
    if (aNewFields.length === 0) return
    let aVisibleFields = []
    let aFieldsRemoved = aNewFields

    for (let i = aNewFields.length - 1; i >= 0; i--) {
      const oField = aNewFields[i]
      const existingFieldIndex = aVisibleFields.findIndex(
        (field) => field?.opfd_nid === oField?.opfd_nid,
      )
      //remove fields in the model
      if (oField?.bis_visible === false || oField?.bis_visible === undefined) {
        aFieldsRemoved.splice(existingFieldIndex, 1)
      }
    }

    fnSetAFields(aFieldsRemoved)
    fnSetANewFields([])
  }, [aNewFields, bIsOpen])

  useEffect(() => {
    ; (async () => {
      const response = await fnShowTutorialReq()
      fnSetBOpenWarningModal(!response.data.opsm_bvisualized)
    })()
    fnSetBDisableButton(false)
  }, [bIsOpen])

  function fnOpenModalCustonField() {
    fnSetBOpenCustomFields(true)
  }

  function fnHandleCloseCustonFields() {
    fnSetBOpenCustomFields(false)
  }

  function fnConfirmCustomField(aNewFields) {
    let oTempFieldsModel = aFields
    aNewFields?.map((oSelectField, i) => {
      if (oSelectField?.bis_visible) {
        const oFieldValue = oTempFieldsModel?.find(
          (oValue) => oValue?.opfd_nid === oSelectField?.opfd_nid,
        )

        if (!oFieldValue) {
          // add new field in model
          oTempFieldsModel.push({
            ...oSelectField,
            opfv_opfd_nid: oSelectField?.opfd_nid,
            opfv_cvalue: "",
            selected_option: null,
            ombf_brequired: false,
            visible_new_form: true,
          })
          fnSetASettingForm((prev) => [
            ...prev,
            { fieldId: oSelectField?.opfd_nid, isVisible: true, required: false },
          ])
        }
      }
      if (!oSelectField?.bis_visible) {
        const indexToRemove = oTempFieldsModel.findIndex(
          (oValue) => oValue?.opfd_nid === oSelectField?.opfd_nid,
        )

        if (indexToRemove !== -1) {
          // remove field in model
          oTempFieldsModel.splice(indexToRemove, 1)
          const aValuesSetting = [...aSettingForm]
          aValuesSetting.splice(indexToRemove, 1)
          fnSetASettingForm(aValuesSetting)
          fnSetBIsRemoved((prev) => !prev)
        }
      }
    })

    fnSetAFields(oTempFieldsModel)

    setValue("fields", [])
    oTempFieldsModel.map(async (temp, i) => {
      const newValue = {
        fieldId: temp.ombf_opfd_nid || temp.opfd_nid,
        name: temp?.opfd_cname,
        slug: temp?.opfd_cslug,
        type: temp?.opfd_ctype,
        isVisible: temp.opvf_bis_visible,
        required: temp.ombf_brequired,
        position: i,
      }
      await setValue(`fields[${i}]`, newValue)
      return temp
    })

    fnSetBOpenCustomFields(false)
    if (oTempFieldsModel.length === 0) {
      setValue("fields", [])
      return
    }
    return false //used to stop the loading on button save custom fields
  }

  useEffect(() => {
    fnSetnInitialHeight(document.querySelector("#modalContent").offsetHeight)
  })

  useEffect(() => { }, [aFields])

  function fnOpenCreateCustomField() {
    fnSetBOpenModalNewCustomField(true)
    fnSetBOpenCustomFields(false)

    // reset edit
    fnSetBOpeEditCustomField(false)
    fnSetOCustomField(null)
  }

  function fnHandleEditCustomField(oField) {
    fnSetBOpenModalNewCustomField(true)
    fnSetBOpenCustomFields(false)

    // add edit config
    fnSetBOpeEditCustomField(true)
    fnSetOCustomField(oField)
  }

  function fnCloseCreateCustomField() {
    fnSetBOpenModalNewCustomField(false)
    fnSetBOpenCustomFields(true)
  }

  async function fnSubmitNewCustomField(oData) {
    if (bOpeEditCustomField) {
      await fnUpdateField(oData)
      await fnRefreshCurrentBoard()
      oUpdateFieldRes.success && fnCloseCreateCustomField()
      return
    }
    const response = await fnCreateActivityFielReq(oData)
    response.success && fnCloseCreateCustomField()
  }

  const fnHandleDeleteField = (index) => {
    const updatedFields = aFields.filter((field, i) => i !== index)
    fnSetAFields(updatedFields)
  }

  return (
    <>
      <div className={styles.container} ref={containerRef} id="fieldContainer">
        <Typography type="l2" color="#415364">
          {intl.get("modal_new_form.visible_fields", { blockName: blockName?.label })}
        </Typography>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable
            direction="vertical"
            droppableId="modelActivityDrop"
            height={"100%"}
            renderClone={(provided, snapshot, rubric) => (
              <div
                className={styles.draggableItem}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={provided.draggableProps.style}
                ref={provided.innerRef}
              >
                <RcmpActivityField
                  {...aFields[rubric.source.index]}
                  opfd_cname={aFields[rubric.source.index]?.opfd_cname}
                  ombf_bautofill={aFields[rubric.source.index]?.ombf_bautofill}
                  opfd_cslug={aFields[rubric.source.index]?.opfd_cslug}
                  opfd_ctype={aFields[rubric.source.index]?.opfd_ctype}
                  opfd_nid={aFields[rubric.source.index]?.opfd_nid}
                  bIsDraggable={true}
                  bIsDisabled={true}
                  bIsEditModel={true}
                />
              </div>
            )}
          >
            {(provided, snapshot) => (
              <div
                className={styles.contentModal}
                id="contentModal"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                <div>
                  {aFields.length ? (
                    aFields?.map((field, i) => {
                      return (
                        <>
                          <RcmpFieldsRow
                            key={i}
                            field={field}
                            cFieldRequired={cFieldRequired}
                            fnSetCFieldRequired={fnSetCFieldRequired}
                            index={i}
                            fnDeleteField={fnHandleDeleteField}
                            fnSetAFields={fnSetAFields}
                            aFields={aFields}
                            fnSetARadioSelect={fnSetARadioSelect}
                            aRadioSelect={aRadioSelect}
                            setValue={setValue}
                            getValues={getValues}
                            values={aSettingForm}
                            fnSetAValues={fnSetASettingForm}
                            watch={watch}
                            bOnDraggingEnd={bOnDraggingEnd}
                            bIsEdit={bIsEdit}
                            bIsRemoved={bIsRemoved}
                          />
                        </>
                      )
                    })
                  ) : (
                    <div className={styles.notFieldsForm}>
                      <Typography textAlign="center" type="p1" color="#5A646E">
                        {intl.get("form.not_fields")}
                      </Typography>
                    </div>
                  )}
                  {provided.placeholder}
                </div>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      <RcmpModalCreateNewCustomField
        bIsOpen={bOpenModalNewCustomField}
        fnCancel={fnCloseCreateCustomField}
        fnHandleConfirm={fnSubmitNewCustomField}
        oCreateActivityFieldRes={oCreateActivityFieldRes}
        bIsEdit={bOpeEditCustomField}
        oField={oCustomField}
      />

      {bOpenCustomField && <RcmpModalCustomFields
        bIsOpen={bOpenCustomField}
        buttonCancelText={intl.get("cancel")}
        buttonSaveText={intl.get("BlocksPage.save_changes")}
        title={intl.get("BlocksPage.add_fields")}
        fnOpenModalNewCustomField={fnOpenCreateCustomField}
        fnEditCustomField={fnHandleEditCustomField}
        textHead={intl.get("BlocksPage.custom_fields")}
        size={"lg"}
        fnHandleCancel={fnHandleCloseCustonFields}
        fnHandleConfirm={fnConfirmCustomField}
        aCheckedFields={aFields}
        bDisableDefaultFields={true}
        bIsEdit={false}
        bNewFormCriation={true}

      />}
    </>
  )
}

function RcmpFourthStep(props) {
  const qrCodeRef = useRef(null)
  const cFormLink = window.location.origin + process.env.PUBLIC_URL + '/activityForm/'

  const { fnCloseModal, ofnCreateNewFormRes, getValues, bShareForm, oForm, bIsEdit } =
    props
  const { oUser } = useContext(AuthContext)
  const nFormIdToShare =
    bShareForm || bIsEdit ? oForm.id : ofnCreateNewFormRes?.data?.data?.opbform_nid
  const cFormName = oForm.formName || getValues("formName")

  function fnOpenCopied() {
    return toast({
      type: "success",
      title: intl.get("modal_new_form.link_copied"),
    })
  }

  function fnOpenEmbedCopied() {
    return toast({
      type: "success",
      title: intl.get("modal_new_form.embed_copied"),
    })
  }

  async function downloadQR() {
    const canvas = document.getElementById("qrCodeForm")

    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/jpg")
        .replace("image/jpg", "image/octet-stream")
      let downloadLink = document.createElement("a")
      downloadLink.href = pngUrl
      downloadLink.download = `qrCode_${cFormName}.jpg`
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    } else {
      console.error("QR Code canvas not found.")
    }
  }

  function fnCopyEmbed() {
    const iframeElement = `<iframe title="Página Incorporada"src=${cFormLink + nFormIdToShare
      }/${oUser.data.cust_nid} width="900" height="1024"/>`

    navigator.clipboard.writeText(iframeElement)
    fnOpenEmbedCopied()
  }

  function fnCopyFormLink() {
    const cLink = `${cFormLink}${nFormIdToShare}/${oUser.data.cust_nid}`
    navigator.clipboard.writeText(cLink)
    fnOpenCopied()
  }

  return (
    <div className={styles.containerShareForm}>
      {!bShareForm && (
        <div>
          <span className={styles.doneConfirmation}>
            {intl.get("modal_new_form.conclude_form")}
            <span>{intl.get("modal_new_form.conclude_form_info")}</span>
          </span>
        </div>
      )}

      <div className={bShareForm ? styles.shareFormsActive : styles.actionShareForms}>
        <div>
          <LinkShareIcon onClick={fnCopyFormLink} />
          <Button type="button" onClick={fnCopyFormLink}>
            {intl.get("modal_new_form.copy_link")}
          </Button>
        </div>
        <div>
          <QRCodeCanvas
            id="qrCodeForm"
            value={`${cFormLink + nFormIdToShare}/${oUser.data.cust_nid}`}
            renderAs={"canvas"}
            size={1024}
            level={"L"}
            includeMargin={false}
            ref={qrCodeRef}
            style={{ display: "none" }}
          />
          <QrCodeIcon onClick={downloadQR} />
          <Button type="button" onClick={downloadQR}>
            {intl.get("modal_new_form.copy_qrcode")}
          </Button>
        </div>
        <div>
          <EmbedIcon onClick={fnCopyEmbed} />
          <Button type="button" onClick={fnCopyEmbed}>
            {intl.get("modal_new_form.copy_embed")}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default function RcmpModalNewForm(props) {
  const {
    bIsOpen,
    bIsEdit,
    fnOnClose,
    aBlocks,
    oCurrentBoard,
    bShareForm = false,
    oForm,
  } = props

  function fnFormatDataToEditForm() {
    if (!bIsEdit || !oForm) return null
    const oBlockSelectedEdit = aBlocks.filter((block) => block.opbl_nid === oForm.blockId)
    const formatedValueSelectedBlockEdit = {
      label: oBlockSelectedEdit[0]?.opbl_cname,
      value: oBlockSelectedEdit[0]?.opbl_nid,
    }
    let aResponsiblesOnEditForm = oForm.responsibles?.map((responsible) => {
      return {
        label: responsible.user_cname,
        value: responsible.user_nid,
      }
    })
    let formatedFields = oForm.fields.map((field) => {

      return {
        visible_new_form: field.isVisible,
        opvf_bis_visible: field.isVisible,
        opfd_nid: field.field_id,
        opfd_cname: field.name,
        options: field.options,
        position: field.position,
        precision: field.precision,
        opfd_cprefix: field.prefix,
        ombf_brequired: field.required,
        opfd_cslug: field.slug,
        opfd_csuffix: field.suffix,
        opfd_ctype: field.type,
        ombf_bautofill: field.autofill,
      }
    })
    formatedFields.sort((a, b) => a.position - b.position)
    return {
      ...oForm,
      blockId: formatedValueSelectedBlockEdit,
      timeRanger: { label: "", value: oForm.timeRanger },
      responsibles: aResponsiblesOnEditForm,
      fields: formatedFields,
    }
  }

  const formatedDataEditForm = fnFormatDataToEditForm()
  const [bValidate, fnSetBValidate] = useState(true)
  const aSteps = [
    intl.get("modal_new_form.begin"),
    intl.get("BoardsPage.responsibles"),
    intl.get("modal_new_form.form_fields"),
    intl.get("modal_new_form.share"),
  ]
  const [nStep, fnSetNStep] = useState(bShareForm ? 4 : 1)
  const [oBlockSelected, fnSetOblockSelected] = useState({})
  const [bIsLoading, fnSetBIsLoading] = useState(false)
  const [bIsOpenModalInfo, fnSetBIsOpenModalInfo] = useState(false)
  const [bIsEmptyForm, fnSetBIsEmptyForm] = useState(true)
  const { fnNewForm, ofnCreateNewFormRes, fnUpdateFormActivity } = useContext(FormContext)
  const [aFieldsNewForm, fnSetAFieldsNewForm] = useState([])
  const [aSettingForm, fnSetASettingForm] = useState([])
  const useFormMethods = useForm({})
  const buttonRef = useRef(null)
  const modalContainerRef = useRef(null)
  const oBoardModel = oCurrentBoard.board_model || oCurrentBoard.data[0].board_model
  let newObj = oBoardModel?.fields?.map(({ field, ...rest }) => ({
    ...rest,
    ...field,
  }))
  let aFormatedData = newObj
    ?.map((obj) => {
      if (
        obj.opfd_cslug === cStatusSlug ||
        obj.opfd_cslug === cDeadLineSlug ||
        obj.opfd_cslug === dCreationDateSlug ||
        obj.opfd_cslug === dConclusionDateSlug ||
        obj.opfd_ctype === "PEOPLES" ||
        obj.opfd_ctype === "CALC"
      ) {
        return null
      }
      if (bIsEdit) {
        const field = oForm.fields.find((field) => field.field_id === obj.opfd_nid)
        return {
          ...obj,
          ombf_brequired: field?.required,
          opvf_bis_visible: field?.isVisible,
          visible_new_form: field?.isVisible,
        }
      }
      return {
        ...obj,
        ombf_brequired: false,
        opvf_bis_visible: true,
        visible_new_form: true,
      }
    })
    .filter((item) => item !== null)

  useEffect(() => {
    if (!aFormatedData) return
    fnSetAFieldsNewForm(aFormatedData)
  }, [])

  useEffect(() => {
    if (aSettingForm.length === 0 && bIsOpen && !bIsEdit) {
      let fieldParams = aFieldsNewForm.map((field, i) => ({
        fieldId: field.ombf_opfd_nid || field.opfd_nid,
        isVisible: true,
        required: false,
        name: field?.opfd_cname,
        slug: field?.opfd_cslug,
        type: field?.opfd_ctype,
        position: i,
      }))
      fnSetASettingForm(fieldParams)
    }
    if (bIsEdit) {
      oForm.fields.sort((a, b) => a.position - b.position)
      fnSetASettingForm(oForm.fields)
    }
  }, [nStep])

  const schema =
    nStep === 1
      ? yup.object().shape({
        blockId: yup
          .object()
          .shape({
            label: yup.string(),
            value: yup.number(),
          })
          .required(intl.get("form.required_field")),
        formName: yup
          .string()
          .trim()
          .required(intl.get("form.required_field"))
          .test(
            "isWhitespace",
            "Não é permitido somente espaço em branco.",
            (value) => {
              return !/^\s*$/.test(value)
            },
          ),
        formDescription: yup.string().nullable(),
      })
      : nStep === 2
        ? yup.object().shape({
          responsibles: yup
            .array()
            .of(
              yup.object().shape({
                label: yup.string(),
                value: yup.number(),
              }),
            )
            .required(intl.get("form.required_field")),
          timeRanger: yup.object().shape({
            label: yup.string().default("Horas"),
            value: yup.string().default("hour"),
          }),
          timeValue: yup.number().min(1),
          evidenceUpload: yup.boolean().default(false),
        })
        : yup.object().shape({
          fields: yup
            .array()
            .of(
              yup.object().shape({
                fieldId: yup.number(),
                slug: yup.string(),
                required: yup.boolean().default(false),
                isVisible: yup.boolean().default(true),
                position: yup.number(),
                name: yup.string(),
                type: yup.string(),
              }),
            )
            .min(1)
            .required(),
        })

  const aFields = [
    "blockId",
    "formName",
    "formDescription",
    "responsibles",
    "timeRange",
    "timeValue",
    "evidenceUpload",
    "fields",
  ]

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    reset,
    watch,
    trigger,
    formState: { errors, isDirty },
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    reset({})
    setValue("timeValue", 1)
  }, [bIsOpen])

  useEffect(() => {
    if ((!bIsEdit || !bIsOpen) && !formatedDataEditForm) return
    reset(formatedDataEditForm)
    fnSetAFieldsNewForm(formatedDataEditForm.fields)
  }, [bIsEdit, bIsOpen, oForm])

  function fnOpenToastFail() {
    return toast({
      type: "error",
      title: intl.get("table_fields.toast.fail"),
      description: bIsEdit
        ? intl.get("modal_new_form.error_submit_edit_form")
        : intl.get("modal_new_form.error_submit"),
    })
  }

  function fnConfirmModalInfo() {
    fnSetBIsOpenModalInfo(false)
    fnSetNStep(1)
    fnSetAFieldsNewForm([])
    fnSetASettingForm([])
    fnOnClose()
  }

  function fnCancelModalInfo() {
    fnSetBIsOpenModalInfo(false)
  }

  useEffect(() => {
    if (!bIsOpen) return
    const bIsEmpty = aFields.every((campo) => {
      return !getValues(campo)
    })
    fnSetBIsEmptyForm(bIsEmpty)

    if (nStep === 1 && getValues("blockId") && getValues("formName")) {
      ; (async () => {
        try {
          await schema.validate(getValues(), { context: 1, abortEarly: true })
          fnSetBValidate(false)
        } catch (validationError) {
          fnSetBValidate(true)
        }
      })()
      return
    }
    if (
      nStep === 2 &&
      getValues("responsibles") &&
      getValues("responsibles").length > 0 &&
      getValues("timeValue") > 0
    ) {
      fnSetBValidate(false)
      return
    }
    if (nStep === 3) {
      ; (async () => {
        try {
          await schema.validate(getValues(), { context: 3, abortEarly: true })
          fnSetBValidate(false)
        } catch (validationError) {
          fnSetBValidate(true)
        }
      })()
      return
    }
    fnSetBValidate(true)
    return
  }, [watch()])

  const validateStep = async (step) => {
    try {
      await schema.validate(getValues(), { context: { step } })
      return true
    } catch (validationError) {
      return false
    }
  }
  async function fnFormatFormPaylod(data) {
    const oValues = getValues()
    const responsibles = oValues?.responsibles?.map((responsible) => responsible.value) || []
    const cNameWithoutSpace = oValues.formName.trimStart()
    let payloadNewForm = {
      blockId: oValues.blockId.value,
      formName: cNameWithoutSpace,
      formDescription: oValues.formDescription,
      responsibles: responsibles,
      evidenceUpload: oValues.evidenceUpload,
      timeRanger: oValues.timeRanger.value,
      timeValue: oValues.timeValue,
      fields: oValues.fields,
    }
    if (bIsEdit) {
      const response = await fnUpdateFormActivity(oForm.id, payloadNewForm)
      if (response) {
        fnSetBIsLoading(false)
        return true
      }
      fnOpenToastFail()
      fnSetBIsLoading(false)
      return false
    }
    const response = await fnNewForm(payloadNewForm)
    if (response) {
      fnSetBIsLoading(false)
      return true
    }
    fnOpenToastFail()
    fnSetBIsLoading(false)
    return false
  }

  function fnScrollToTop() {
    if (modalContainerRef.current) {
      modalContainerRef.current.scrollIntoView()
      modalContainerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      })
    }
  }

  useEffect(() => {
    fnScrollToTop()
  }, [nStep])

  async function fnNextStep() {
    if (nStep + 1 <= aSteps.length && (await validateStep(1)) && nStep === 1) {
      fnSetNStep(nStep + 1)
      return
    }
    if (nStep + 1 <= aSteps.length && (await validateStep(2)) && nStep === 2) {
      fnSetNStep(3)
      return
    }
    if (nStep === 3 && getValues("fields").length > 0) {
      fnSetBIsLoading(true)
      const response = await fnFormatFormPaylod()
      response && fnSetNStep(nStep + 1)
      return
    }
    return
  }

  function fnPrevStep() {
    if (nStep - 1 >= 1) {
      fnSetNStep(nStep - 1)
      return
    }
    return
  }
  function submitForm(data) {
    if (nStep <= 3) return
    fnSetNStep(1)
    fnOnClose()
  }

  function fnCloseModal() {
    if (isDirty && !bIsEmptyForm && nStep != 4) {
      fnSetBIsOpenModalInfo(true)
      return
    }
    fnSetNStep(1)
    fnSetAFieldsNewForm([])
    fnSetASettingForm([])
    fnOnClose()
  }

  return (
    <div>
      <Modal isOpen={bIsOpen} size="lg">
        <Modal.Header onClose={fnCloseModal}>
          {bIsEdit
            ? intl.get("modal_new_form.edit_form", { form: oForm.formName })
            : intl.get("modal_new_form.new_form")}
        </Modal.Header>
        <form id="activity-form" onSubmit={handleSubmit(submitForm)}>
          <Modal.Content>
            <FormProvider {...useFormMethods}>
              <div
                className={styles.modalContent}
                ref={modalContainerRef}
                id="modalContent"
              >
                {!bShareForm && <RcmpSteps aData={aSteps} nStep={nStep} />}
                {nStep === 1 && (
                  <RcmpFirstStep
                    aBlocks={aBlocks}
                    fnSetOblockSelected={fnSetOblockSelected}
                    setValue={setValue}
                    register={register}
                    errors={errors}
                    getValues={getValues}
                  />
                )}
                {nStep === 2 && (
                  <RcmpSecondtStep
                    oBlockSelected={oBlockSelected}
                    oCurrentBoard={oCurrentBoard}
                    setValue={setValue}
                    register={register}
                    getValues={getValues}
                  />
                )}
                {nStep === 3 && (
                  <RcmpThirdStep
                    aFields={aFieldsNewForm}
                    fnSetAFields={fnSetAFieldsNewForm}
                    nStep={nStep}
                    bIsOpen={bIsOpen}
                    setValue={setValue}
                    register={register}
                    getValues={getValues}
                    aSettingForm={aSettingForm}
                    fnSetASettingForm={fnSetASettingForm}
                    watch={watch}
                    trigger={trigger}
                    bIsEdit={bIsEdit}
                  />
                )}
                {nStep === 4 && (
                  <RcmpFourthStep
                    bShareForm={bShareForm}
                    oForm={oForm}
                    ofnCreateNewFormRes={ofnCreateNewFormRes}
                    nStep={nStep}
                    bIsOpen={bIsOpen}
                    setValue={setValue}
                    register={register}
                    getValues={getValues}
                    fnCloseModal={fnCloseModal}
                    bIsEdit={bIsEdit}
                  />
                )}
              </div>
            </FormProvider>
          </Modal.Content>
          <Modal.Footer>
            <div className={styles.footerArea}>
              {nStep !== aSteps.length ? (
                <>
                  <Button type="button" variant="outline" onClick={fnCloseModal}>
                    {intl.get("cancel")}
                  </Button>
                  <div className={styles.navigateButtons}>
                    <Button
                      iconLeft={<ArrowLeftIcon />}
                      disabled={nStep === 1}
                      onClick={fnPrevStep}
                    >
                      {intl.get("back")}
                    </Button>
                    <Button
                      iconRight={<ArrowRightIcon />}
                      onClick={fnNextStep}
                      disabled={bValidate}
                      ref={buttonRef}
                      type="button"
                      isLoading={bIsLoading}
                    >
                      {intl.get("next")}
                    </Button>
                  </div>
                </>
              ) : (
                <div className={styles.doneForm}>
                  <Button type="button" onClick={fnCloseModal}>
                    {intl.get("modal_new_form.done")}
                  </Button>
                </div>
              )}
            </div>
          </Modal.Footer>
        </form>
      </Modal>
      <RcmpModalInfo
        bIsOpen={bIsOpenModalInfo}
        description={intl.get("modal_new_form.warning_text_form")}
        subText={intl.get("modal_new_form.warning_text_subText")}
        title={intl.get("cancel")}
        buttonCancelText={intl.get("activityModelModal.close_when_change_field_cancel")}
        buttonSaveText={intl.get("activityModelModal.close_when_change_field_sure")}
        size={"sm"}
        fnHandleConfirm={fnConfirmModalInfo}
        fnHandleCancel={fnCancelModalInfo}
      />
    </div>
  )
}
